// extracted by mini-css-extract-plugin
export var profession = "profession-mod--profession--3166K";
export var profession__card = "profession-mod--profession__card--1c1_F";